import React from 'react';
import Input from 'blocks/Input';
import {inject, observer} from 'mobx-react';
import className from 'classnames';
import _ from 'lodash';
import DateTimeWrapper from 'blocks/DateTimeWrapper';
import Checkbox from 'blocks/filters/Checkbox';

@inject('onlineWorkshop')
@observer
export default class SingleCode extends React.Component {


  state = {focusedInput: false};

  handleChange = e => {
   this.props.onlineWorkshop.handleChangeCoupon(e, this.props.el.id)
  };

  deleteCoupon = () => {
    this.props.onlineWorkshop.handleDeleteCoupon(this.props.el.id)
  };

  handleChangePrice = e => {
  if(!e.cost || e.cost.match(/^[0-9]+[.]?[0-9]{0,2}$/g))
    this.props.onlineWorkshop.handleChangeCoupon(e, this.props.el.id)
  };

  handleSetFree = e => this.props.onlineWorkshop.handleChangeCouponIsFree({is_free: e.checked}, this.props.el.id)

  render() {
    const coupon = this.props.onlineWorkshop.getCouponById(this.props.el.id);
    const errors = this.props.onlineWorkshop.getCouponsErrorsById(this.props.el.id) || {};
    return (
      <div className="row coupon customregular-dates" style={coupon._destroy && {display: 'none'}}>
        <div className="offset-4 offset-md-3" style={{display: 'inherit'}}>
          <div className="col-3">
            <Input name="cost"
                   type="text"
                   value={coupon.cost}
                   disabled={coupon.is_free}
                   error={!_.isEmpty(errors.cost) && errors.cost}
                   handleChange={this.handleChangePrice}
                   placeholder="Discounted price"/>
          </div>
          <span style={{display: 'flex', alignItems: 'center'}}>OR</span>
          <div style={{display: 'flex', alignItems: 'flex-end'}}>
            <Checkbox
              id={coupon.id}
              name={`is_coupon_free_${coupon.id}`}
              handleChange={this.handleSetFree}
              checked={coupon.is_free}
              value={this.props.el.id}
              label={'Set free'}
              fullWidth
            />
          </div>
          <div className="col-3">
            <Input name="code"
                   type="text"
                   value={coupon.code}
                   maxlength={8}
                   error={errors.code && errors.code.length > 0 && errors.code}
                   handleChange={this.handleChange}
                   placeholder="Discount code"/>
          </div>
          <div className="col-3">
            <div className={className('accordion-content-block accordion-content-block-date',
              {
                'active-date': coupon.expiry_date,
                'dates-error': (!_.isEmpty(errors.expiry_date) && errors.expiry_date)
              })}>


              <DateTimeWrapper value={coupon.expiry_date}
                               handleChange={this.handleChange}
                               error={!_.isEmpty(errors.expiry_date) && errors.expiry_date}
                               name="expiry_date"/>

            </div>
          </div>
          <div className="col-1"
               style={{marginTop: 30, cursor: 'pointer', opacity: 0.74}}
               onClick={this.deleteCoupon}>
            <i className="ic-close-ico"/>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/create_workshop/SingleCode.jsx